module.exports = __webpack_public_path__ + "img/slider_17.68ca1701.jpg";